module.exports = __webpack_public_path__ + "static/img/takeover1.3a688406.png";